import App from './views/App.vue';
import router from './routes';
import './components/form/CmsLoginForm';

import AkApprovalStatusSelect from "./widgets/AkApprovalStatusSelect.vue";

Vue.component('ak-approval-status-select', AkApprovalStatusSelect);

let app = new Vue({
        data() { 
            return {
                globalMessages: []
            }
        },
        router,
        render: h => h(App),
}).$mount('#app')

AppKit.init(app);
